import "./Faq.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Questions from "./sections/Questions";
export default function FaqPage() {
  return <div>
      <Header publicPage />

      <main>
        <Questions />
      </main>

      <Footer />
    </div>;
}